// hooks/useCountry.ts
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { updateBackendOptions } from "../i18n";
import i18n from "../i18n";
import { setItem } from "./localStorageUtil";
import { usePageTransition } from "./usePageTransition";
import { useCallback } from "react";

const LATAM_ISOS = new Set([
  "co", "cr", "ec", "sv", "gt", "hn", "ni", "pa", "py", "pe", "uy", "mx", "do", "bo"
]);
//saqué bolivia a pedido

const INTERNAL_WEBSITE_TYPES = ["internal_website", "internal_website_b2b", "internal_website_custom_solutions"];

export const useCountry = () => {
  const navigate = useNavigate();
  const countriesData = useSelector((state) => state.country.data);
  const isLoading = useSelector((state) => state.country.loading);
  const { startFade } = usePageTransition();

  const isLatamISO = useCallback((iso) => {
    return !!iso && LATAM_ISOS.has(iso.toLowerCase());
  }, []);

  const isLatamCountry = useCallback((country) => {
    return isLatamISO(country?.iso_country);
  }, [isLatamISO]);

  const setCountryChange = (selectedCountry) => {
    if (!selectedCountry) return;

    if (
      INTERNAL_WEBSITE_TYPES.includes(selectedCountry.country_type) &&
      selectedCountry.iso_country &&
      selectedCountry.iso_country.length > 0
    ) {
      const iso_country = selectedCountry.iso_country.toLowerCase();
      const env = "prod";

      setItem("isoCountry", iso_country);
      setItem("env", env);
      updateBackendOptions({ newCountryId: iso_country, newEnv: env });
      i18n.changeLanguage(iso_country);

      startFade(() => {
        // navigate(`/${iso_country}`);
        // navigate(0);
        window.location.href = `/${iso_country}`;
      });

    } else if (
      selectedCountry.country_type === "external_website" &&
      selectedCountry.external_website &&
      selectedCountry.external_website.length > 0
    ) {
      window.open(selectedCountry.external_website, "_blank");
    } else if (selectedCountry.country_type === "product_commercialization") {
      navigate(`/gl/product-b2b-list/${selectedCountry.id}`);
    } else if (selectedCountry.country_type === "contact_form") {
      navigate(`/gl/product-b2b-contact/${selectedCountry.id}`);
    }
  };

  const getGlobalData = (countryList = null) =>
    (countryList || countriesData).find((c) => parseInt(c.id) === 1) || {};

  const getCountryData = (country, list) => {
    const defaultCountry = getGlobalData(list);
    if (!country) return defaultCountry;

    return {
      ...country,
      isInternalWebsite: INTERNAL_WEBSITE_TYPES.includes(country.country_type),
      ...Object.fromEntries(
        Object.entries(country).map(([key, value]) => [
          key,
          value !== null &&
            (typeof value === "number" ||
              (typeof value === "string" && value.trim() !== "") ||
              typeof value === "boolean")
            ? value
            : defaultCountry[key],
        ])
      ),
    };
  };

  const getCountryDataBtId = (countryId, countryList = null) => {
    const list = countryList || countriesData;
    const country = list.find((c) => parseInt(c.id) === parseInt(countryId));
    return getCountryData(country, list);
  };

  const getCountryDataByISO = (isoCountry, countryList = null) => {
    if (!isoCountry) return getCountryData(null, countryList);
    const normalizedIso = isoCountry.toLowerCase();
    const list = countryList || countriesData;
    const country = list.find(
      (c) => c?.iso_country?.toLowerCase() === normalizedIso
    );
    return getCountryData(country, list);
  };

  return {
    setCountryChange,
    getGlobalData,
    getCountryDataBtId,
    getCountryDataByISO,
    isLatamISO,
    isLatamCountry,
    isLoading,
    countriesData,
  };
};
